import React, { useEffect, useState } from "react";
import Login from "./src/screen/Login";

export default function App() {
  return (
    <Login />
  );
}